module.exports = __webpack_public_path__ + "img/dataflow-02.31a61723.svg";